import { withInstall } from '@/utils'
import SellerButton from './src/index.vue'
export default withInstall(SellerButton)
